.callout {
  display: grid;
  gap: var(--space-2);
  padding: var(--space-4);
  border: 1px solid var(--border);
  border-inline-start-width: 3px;
  border-radius: var(--radius-md);
  background: var(--surface);
}

.title {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  font-family: var(--font-body);
  font-size: var(--text-base);
  font-weight: 600;
  letter-spacing: 0;
}

.body {
  color: var(--text-muted);
  max-inline-size: var(--measure);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  margin-block-start: var(--space-1);
}

.note {
  border-inline-start-color: var(--border-strong);
}

.warning {
  border-inline-start-color: var(--warning);
}

.warning .title {
  color: var(--warning);
}

.error {
  border-inline-start-color: var(--danger);
}

.error .title {
  color: var(--danger);
}

.marker {
  inline-size: 16px;
  block-size: 16px;
  flex: none;
}
